import React, { useState } from "react";
import "./Retrocheck.scss";
import { Chart } from "react-google-charts";

export const RetrocheckFileSummary = ({data,fileSummary }) => {
    const options = {
        legend: "none",
        pieSliceText: "label",
        title: `Coverage Discovered ${fileSummary.coverageDicoveredPercentage} %`,
        pieStartAngle: 100,
        titleTextStyle: {
            fontSize: 34,
            bold: true, 
        }
      };

    data = [
        ["CoverageType", "Percentage Of Records"],
        ["No Coverage", fileSummary.noCoverageFoundPercentage],
        ["Medicaid", fileSummary.medicaidCoveragePercentage],
        ["Medicare", fileSummary.medicareCoveragePercentage],
        ["Private", fileSummary.privateCoveragePercentage],
    ];

    return (
        <div className="summary_section">
            <div className="leftSection">
                <div className="square">
                    <p className="fileInfo">Total Accounts Processed</p>
                    <p className="fileInfo">{fileSummary.totalProcessedRecords}</p>
                </div>
                <div className="square">
                    <p className="fileInfo">Coverage Found</p>
                    <p className="fileInfo">{fileSummary.totalCoveragesFound}</p>
                </div>
            </div>
            <div className="rightSection">
            <div>
                <Chart
                    chartType="PieChart"
                    data={data}
                    options={options}
                    width="100%"
                    height="500px"
                />
            </div>
            </div>
        </div>
    );
};
